import { deserialize, serialize } from "serializr";

import _axiosInstance from "../../interceptor/_axiosInstance";
import axiosInstance from "../../interceptor/axiosInstance";

import { FilterChapterwise, ChapterwiseSummaryModel } from "../../models/ReportsModel/chapterwise.model";


import { CHAPTERWISE_REPORT, DOWNLOAD_CHAPTERWISE_REPORT } from "../../routes/routeConstants/apiRoutes";
import { defaultFilterReports } from "../../shared/utils/filter";

export default class ChapterwiseReportService {

  static fetchChapterwiseReport(
    data: FilterChapterwise,
    onSuccess: (data: ChapterwiseSummaryModel[]) => void,
    onError: Function,
    onFinal: () => void
  ) {
    const payload = serialize(FilterChapterwise, { ...defaultFilterReports, ...data })
    delete payload.type;
    return axiosInstance.get(CHAPTERWISE_REPORT, { params: payload })
      .then(response => {
        const data = deserialize(ChapterwiseSummaryModel, response?.["data"]) as ChapterwiseSummaryModel[];
        onSuccess(data);
      })
      .catch(error => {
        onError(error)
      })
      .finally(onFinal)
  }

  static downloadChapterwiseReport(
    data: FilterChapterwise,
    onSuccess: (value: any) => void,
    onError: Function,
    onFinal: () => void
  ) {
    const payload = serialize(FilterChapterwise, { ...defaultFilterReports, ...data })
    delete payload.type;
    return _axiosInstance.get(DOWNLOAD_CHAPTERWISE_REPORT, { params: payload })
      .then((response) => new Blob([response.data]))
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          `Report.csv`,
        );
        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode?.removeChild(link);

        onSuccess("Download");
      })
      .catch((e) => {
        onError(e);
      })
      .finally(onFinal);
  }

}   